import React, { useRef, useState } from 'react'
import FoldableTableHOC from 'react-table/lib/hoc/foldableTable';
import ReactTable from 'react-table';
import { cancelRequest, confirmRequest, getAllCashlessPhysiotherapyRequests } from '../../services/api/cashless-physiotherapy'
import { OuterComponent, PaddedContainer } from '../customer-support/StyledComponent'
import NavBar from '../layout/NavBar'
import { ButtonGroup, Row } from 'reactstrap';
import { SearchBox, SearchBoxContent, SearchBoxInput } from './styled-elements';
import { FaSearch } from 'react-icons/fa'
import useAfterInitialEffect from './hooks/useAfterInitialEffect';
import LoadingComponent from '../common/LoadingComponent';
import PhysiotherapyModalConfirm from './modals/PhysiotherapyModalConfirm';
import { toast } from 'react-toastify';
import PhysiotherapyModalCancel from './modals/PhysiotherapyModalCancel';
import PhysiotherapyCallModal from './modals/PhysiotherapyCallModal';
import { connect } from 'react-redux';
import { hidePhysiotherapyRequestModal, showPhysiotherapyRequestModal } from '../../actions';
// import PhysiotherapyRequestDetails from './modals/PhysiotherapyRequestDetails';
import DownloadCsv from '../common/DownloadCsv';
import useTableColumns from './hooks/useTableColumns';
import PhysiotherapyClaimModal from './modals/PhysiotherapyClaimModal';
import PhysiotherapyCommentModal from './modals/PhysiotherapyCommentModal';
import moment from 'moment';
import SubContainer from './components/SubContainer';
import PhysiotherapyShiftRequestModal from './modals/PhysiotherapyShiftRequestModal';
import PhysiotherapyRequestDetails from './modals/PhysiotherapyRequestDetails';

const FoldableTable = FoldableTableHOC(ReactTable); 
const initialDates = {
    startDate: null,
    endDate: null,
}
const defaultCallAlertData = { isOpen: false, header: '', body: '', onSubmit: null, requestId: null, onClose: null }

const CashlessPhysiotherapy = ({
    dispatch,
    cashlessPhysiotherapy: stateDetails
}) => {
    
    const [isLoading, setIsLoading] = useState(true)
    const [data, setData] = useState([])
    const [makeSearch, setMakeSearch] = useState('')
    const [totalRecords, setTotalRecords] = useState(0)
    const [requestIdFilter, setRequestIdFilter] = useState('')
    const [parentIdFilter, setParentIdFilter] = useState('')
    const [centerFilter,setRequestCenterFilter] = useState('')
    const [sponsorFilter,setRequestSponsorFilter] = useState('')
    const [vaccinationFilter, setRequestPhysiotherapyFilter] = useState('');
    const [statusFilter, setStatusFilter] = useState('')
    const [appointmentDateFilter, setAppointmentDateFilter] = useState(initialDates)
    const [requestDateFilter, setRequestDateFilter] = useState(initialDates)
    const [appTimeFilter, setAppTimeFilter] = useState(['', ''])
    const [pages, setPages] = useState(0)
    const [pageSize, setPageSize] = useState(20)
    const [currentPage, setCurrentPage] = useState(0)
    const [requestId, setRequestId] = useState(null)
    const [confirmModalIsOpen, setConfirmModalIsOpen] = useState(false)
    const [cancelModalIsOpen, setCancelModalIsOpen] = useState(false)
    const [callAlertData, setCallAlertData] = useState(defaultCallAlertData)
    const [ackFilter, setAckFilter] = useState('')
    const [showClaimModal, setShowClaimModal] = useState(false)
    const [claimRequestId, setClaimRequestId] = useState(null)
    const [showEditPayment, setShowEditPayment] = useState(false)
    const [editPaymentRequestId, setEditPaymentRequestId] = useState(null)
    const [showShiftRequest, setShowShiftRequest] = useState(false)
    const [shiftRequestId, setShiftRequestId] = useState(null)
    const [showCommentModal, setShowCommentModal] = useState(false)
    const [commentModalRequestId, setCommentModalRequestId] = useState(null)
    const [requestModalOpen, setRequestModalOpen] = useState(false);
    const searchInputRef = useRef(null)
    const requestOpenModal = (requestId) => {
        setRequestModalOpen(true);
        setRequestId(requestId)
    }
    const requestCloseModal = (requestId) =>{
        setRequestModalOpen(false);
        setRequestId(null);
    }
    const confirmOpenModal = (requestId) => {
        setConfirmModalIsOpen(true)
        setRequestId(requestId)
    }

    const confirmModalClose = () => {
        setConfirmModalIsOpen(false)
        setRequestId(null)
    }

    const submitConfirmModal = (dateKey, slotId) => {
        if (!requestId || !slotId || !dateKey) {
            return
        }

        return confirmRequest(requestId, dateKey, slotId)
        .then(() => toast.success('Confirm Request Successful'))
        .catch(() => toast.error('Confirm Request Failed, please try again'))
    }

    const cancelOpenModal = (requestId) => {
        setCancelModalIsOpen(true)
        setRequestId(requestId)
    }

    const cancelCloseModal = () => {
        setCancelModalIsOpen(false)
    }

    const submitCancelModal = (reason, remarks) => {
        if (!requestId || !reason) {
            return toast.error('Please select a reason to continue')
        }
        return cancelRequest(requestId, reason, remarks)
        .then(() => toast.success('Cancel request successful'))
        .catch(() => toast.error('Cancel request failed, please try again'))
    }

    const openClaimRequestButton = (requestId) => {
        setShowClaimModal(true)
        setClaimRequestId(requestId)
    }

    const closeClaimRequestButton = () => {
        setShowClaimModal(false)
        setClaimRequestId(null)
    }

    const openEditPaymentButton = (requestId) => {
        setShowEditPayment(true)
        setEditPaymentRequestId(requestId)
    }

    const closeEditPaymentButton = () => {
        setShowEditPayment(false)
        setEditPaymentRequestId(null)
    }

    const openShiftRequestButton = (requestId) => {
        setShowShiftRequest(true)
        setShiftRequestId(requestId)
    }

    const closeShiftRequestButton = () => {
        setShowShiftRequest(false)
        setShiftRequestId(null)
    }

    const setAckButtonConfirmModal = (requestId) => {
        setCallAlertData({
            isOpen: true,
            header: 'Call User?',
            body: 'Are you sure you want to call user?',
            requestId,
            onSubmit: () => {},
            onClose: () => {
                setCallAlertData(defaultCallAlertData)
            }
        })
    }

    const openRequestCommentModal = (requestId) => {
        setShowCommentModal(true)
        setCommentModalRequestId(requestId)
    }

    const closeRequestCommentModal = () => {
        setShowCommentModal(false)
        setCommentModalRequestId(null)
    }

    const fetchTableData = (currPage, currPageSize, orderBy, orderDir, claimFilter) => {
        const valid = value => typeof value === 'number'
        const dateCheck = (date) => {
            return !date ? date : moment(date).format('YYYY-MM-DD')
        }
        setIsLoading(true)
        const params = {
            draw: valid(currPageSize) ? currPageSize : pageSize,
            page: valid(currPage) ? currPage : currentPage,
            requestId: requestIdFilter,
            parentBookingID: parentIdFilter,
            statusFilter,
            search: makeSearch,
            appointmentDateFilterEndDate: dateCheck(appointmentDateFilter.endDate),
            appointmentDateFilterStartDate: dateCheck(appointmentDateFilter.startDate),
            requestDateFilterStartDate: dateCheck(requestDateFilter.startDate),
            requestDateFilterEndDate: dateCheck(requestDateFilter.endDate),
            acknowledgementCallFilter: ackFilter,
            appointmentTimeFilter: appTimeFilter,
            centerFilter:centerFilter,
            vaccinationFilter:vaccinationFilter,
            sponsorFilter:sponsorFilter
        }
        if (orderBy && orderDir) {
            params.orderBy = orderBy
            params.orderDir = orderDir
        }
        if (claimFilter) {
            params.claimedByFilter = claimFilter
        }
        getAllCashlessPhysiotherapyRequests(params).then((r)=>{console.log("This is the response",r)});
        return getAllCashlessPhysiotherapyRequests(params)
        .then((responseBody) => {
            setIsLoading(false)
            setData(responseBody.result)
            setTotalRecords(responseBody.totalHits || 0)
            setPages(Math.ceil(
                responseBody.totalHits / (valid(currPageSize) ? currPageSize : pageSize)
            ))
        })
    }

    const onFetchData = (state) => {
        let orderBy, orderDir, claimFilter
        if (state.sorted.length) {
            orderBy = state.sorted[0].id
            orderDir = state.sorted[0].desc ? 'DESC' : 'ASC'
        }
        state.filtered.forEach((f) => {
            if (f.id === 'opsUserName') {
                claimFilter = f.value
            }
        })
        fetchTableData(state.page, state.pageSize, orderBy, orderDir, claimFilter)
        setCurrentPage(state.page)
        setPageSize(state.pageSize)
    }

    useAfterInitialEffect(() => {
        fetchTableData()
    }, [
        requestIdFilter,
        parentIdFilter,
        statusFilter,
        appointmentDateFilter,
        requestDateFilter,
        ackFilter,
        makeSearch,
        appTimeFilter,
        centerFilter,
        vaccinationFilter,
        sponsorFilter
    ])

    const handleSearchBar = (event) => {
        const { value } = event.target
        console.log({value, key: event.key})
        if (event.key === 'Enter') {
            setMakeSearch(value)
        }
    }

    const cashlessPhysiotherapyTableColumns = useTableColumns({
        dispatch, showPhysiotherapyRequestModal, setRequestIdFilter, setParentIdFilter, setStatusFilter,
        confirmOpenModal, cancelOpenModal, setRequestDateFilter, setAppTimeFilter,
        setAppointmentDateFilter, setAckButtonConfirmModal, setAckFilter, openClaimRequestButton,
        openEditPaymentButton, openRequestCommentModal, openShiftRequestButton,setRequestCenterFilter,setRequestPhysiotherapyFilter,setRequestSponsorFilter
    }, {
        statusFilter
    }, [statusFilter])
    // const myHeaders = new Headers();
    // myHeaders.append("Authorization", "JWT eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjI5MCwicGxhdGZvcm0iOiJXRUIiLCJ1c2VyVHlwZSI6Im9wcyIsImlhdCI6MTcyMTM2ODIxNywiZXhwIjoxNzIxNDU0NjE3fQ.hMbqfiaIjw7tt27mXDTnnekfl49WfSmbzmEUAQh2YbU");
    
    // const requestOptions = {
    //   method: "GET",
    //   headers: myHeaders,
    //   redirect: "follow"
    // };
    
    // fetch("https://api.samuraijack.xyz/v3/physio/ops/requests", requestOptions)
    //   .then((response) => response.text())
    //   .then((result) => console.log(result))
    //   .catch((error) => console.error(error));
    // console.log("These are the state details: ",stateDetails);
    return <OuterComponent>
        <NavBar />
        <PaddedContainer className='pt-4 mt-5'>
            <Row>
                <div className='col'>
                    <div className='row'>
                        <div className='col-8'>
                            <SearchBox>
                                <SearchBoxInput
                                    ref={searchInputRef} 
                                    placeholder='Search...'
                                    type='text'
                                    onKeyDown={handleSearchBar}
                                />
                                <SearchBoxContent>{totalRecords} records</SearchBoxContent>
                            </SearchBox>
                        </div>
                        <div className="col-1">
                            {isLoading ? (
                                <LoadingComponent />
                            ) : (
                                <button
                                onClick={() => setMakeSearch(searchInputRef.current.value)}
                                className="btn btn-primary"
                                >
                                <FaSearch />
                                </button>
                            )}
                        </div>
                    </div>
                </div>
                <div className='col-2'>
                    <ButtonGroup size='sm'>
                        <DownloadCsv 
                            isCashless
                            callback={() => getAllCashlessPhysiotherapyRequests({
                                draw: totalRecords,
                                search: makeSearch
                            })}
                        />
                    </ButtonGroup>
                </div>
            </Row>
        </PaddedContainer>
        <FoldableTable 
            data={data}
            columns={cashlessPhysiotherapyTableColumns}
            loading={isLoading}
            filterable
            manual
            pages={pages}
            showPaginationTop
            className='-striped -highlight'
            onFetchData={onFetchData}
            pageSizeOptions={[2, 5, 20, 50, 100, 200, 500]}
            defaultSorted={[
                {
                    id: 'requestId',
                    desc: true
                }
            ]}
            SubComponent={(row) => (
                <SubContainer 
                    requestId={row.original.requestId}
                    userId={row.original.userId}
                />
            )}
        />

        {/* for confirming vaccination appointment */}
        <PhysiotherapyModalConfirm 
            modalIsOpen={confirmModalIsOpen}
            openModal={confirmOpenModal}
            closeModal={confirmModalClose}
            submitModal={submitConfirmModal}
            onComplete={fetchTableData}
            requestId={requestId}
        />
        
        <PhysiotherapyModalCancel 
            modalIsOpen={cancelModalIsOpen}
            openModal={cancelOpenModal}
            closeModal={cancelCloseModal}
            submitModal={submitCancelModal}
            onComplete={fetchTableData}
            requestId={requestId}
        />
        
        {/* for calling the patient */}
        <PhysiotherapyCallModal 
            {...callAlertData}
            onComplete={fetchTableData}
        />
    
        {stateDetails?.requestId ? <PhysiotherapyRequestDetails 
            details={stateDetails}
            onClose={() => dispatch(hidePhysiotherapyRequestModal())}
            isOpen={stateDetails && stateDetails.requestId} /> : <></>} 
         {/* <PhysiotherapyRequestDetails 
            details={stateDetails}
            onClose={() => dispatch(hidePhysiotherapyRequestModal())}
            isOpen={stateDetails && stateDetails.requestId}
            
        /> */}

        <PhysiotherapyClaimModal 
            requestId={claimRequestId}
            isOpen={showClaimModal}
            onClose={closeClaimRequestButton}
            onComplete={fetchTableData}
        />

        <PhysiotherapyCommentModal 
            requestId={commentModalRequestId}
            isOpen={showCommentModal}
            onComplete={fetchTableData}
            onClose={closeRequestCommentModal}
        />
        
        <PhysiotherapyShiftRequestModal 
            requestId={shiftRequestId}
            isOpen={showShiftRequest}
            onComplete={fetchTableData}
            onClose={closeShiftRequestButton}
        />
    </OuterComponent>
}

const matchStateToProps = (state) => ({
    cashlessPhysiotherapy: state.cashlessPhysiotherapy
})

export default connect(matchStateToProps)(CashlessPhysiotherapy)